export default {
    'name': 'arrow',
    'width': '16',
    'height': '16',
    'viewBox': '0 0 16 16',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M3.67509 5.25584C3.47983 5.06057 3.16324 5.06057 2.96798 5.25583C2.77272 5.4511 2.77272 5.76768 2.96798 5.96294L7.64643 10.6414C7.74019 10.7352 7.86737 10.7878 7.99998 10.7878C8.13259 10.7878 8.25976 10.7352 8.35353 10.6414L13.032 5.96294C13.2272 5.76768 13.2272 5.4511 13.032 5.25583C12.8367 5.06057 12.5201 5.06057 12.3249 5.25584L7.99998 9.58073L3.67509 5.25584Z\' fill=\'#42A463\'/>'
}
